import { applyMobileWorkbookFonts } from './mobileCompat';
export function validateWorkbook(workbook) {
  const issues = [];
  const sheetNames = new Set();
  const tableNames = new Set();

  (workbook.worksheets || []).forEach((sheet) => {
    if (sheetNames.has(sheet.name)) {
      issues.push({ type: 'duplicate_sheet', sheet: sheet.name });
    }
    sheetNames.add(sheet.name);

    const images = typeof sheet.getImages === 'function' ? sheet.getImages() : [];
    if (images.length > 0) {
      issues.push({ type: 'drawing_object', sheet: sheet.name, count: images.length });
    }

    const merges = sheet.model?.merges || [];
    if (merges.length > 6) {
      issues.push({ type: 'excessive_merges', sheet: sheet.name, count: merges.length });
    }

    (sheet.getTables?.() || []).forEach((table) => {
      const tName = table.name || table.table?.name;
      if (tName) {
        if (tableNames.has(tName)) {
          issues.push({ type: 'duplicate_table', name: tName });
        }
        tableNames.add(tName);
      }
    });
  });

  if (workbook.model?.media?.length) {
    issues.push({ type: 'workbook_media', count: workbook.model.media.length });
  }

  return {
    ok: issues.length === 0,
    sheetCount: workbook.worksheets.length,
    tableCount: tableNames.size,
    issues,
  };
}

export async function writeWorkbook(workbook, { debug = false, mobileCompat = false } = {}) {
  const validation = validateWorkbook(workbook);
  if (!validation.ok) {
    const critical = validation.issues.filter((i) => i.type === 'drawing_object' || i.type === 'workbook_media');
    if (critical.length) {
      throw new Error(`Workbook contains unsupported drawing objects: ${JSON.stringify(critical)}`);
    }
  }
  if (mobileCompat) {
    applyMobileWorkbookFonts(workbook);
  }
  const buffer = await workbook.xlsx.writeBuffer({
    useSharedStrings: !mobileCompat,
    useStyles: true,
  });
  if (debug) {
    // eslint-disable-next-line no-console
    console.log('[ExcelV2]', { validation, bytes: buffer?.byteLength ?? buffer?.length });
  }
  return { buffer, validation };
}
